import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import React from 'react';

interface IconMigrationUtilProps {
  legacyIcon: React.ReactNode;
  newIcon: React.ReactNode;
}

/**
 * Switches between legacy icons / new icons as part of the Sake icon set implementation and migration
 */
export const IconMigrationUtil: React.FunctionComponent<IconMigrationUtilProps> = ({
  legacyIcon,
  newIcon,
}) => {
  const isSakeIconSetEnabled = useFeatureFlagForConsumer('SAKE_ICON_SET');
  return <>{isSakeIconSetEnabled ? newIcon : legacyIcon}</>;
};

export const useIsSakeIconSetEnabled = () => {
  return useFeatureFlagForConsumer('SAKE_ICON_SET');
};
